import { createI18n } from "vue-i18n";
import _ from "lodash";

const imports = {
  en: import.meta.glob('../locales/en/**/*.json', { eager: true, import: 'default' }),
  fr: import.meta.glob('../locales/fr/**/*.json', { eager: true, import: 'default' }),
  de: import.meta.glob('../locales/de/**/*.json', { eager: true, import: 'default' }),
  es: import.meta.glob('../locales/es/**/*.json', { eager: true, import: 'default' }),
  pl: import.meta.glob('../locales/pl/**/*.json', { eager: true, import: 'default' }),
  nl: import.meta.glob('../locales/nl/**/*.json', { eager: true, import: 'default' }),
  it: import.meta.glob('../locales/it/**/*.json', { eager: true, import: 'default' }),
  fi: import.meta.glob('../locales/fi/**/*.json', { eager: true, import: 'default' }),
  ru: import.meta.glob('../locales/ru/**/*.json', { eager: true, import: 'default' }),
  cs: import.meta.glob('../locales/cs/**/*.json', { eager: true, import: 'default' }),
  hu: import.meta.glob('../locales/hu/**/*.json', { eager: true, import: 'default' }),
  ro: import.meta.glob('../locales/ro/**/*.json', { eager: true, import: 'default' }),
  sv: import.meta.glob('../locales/sv/**/*.json', { eager: true, import: 'default' }),
  tr: import.meta.glob('../locales/tr/**/*.json', { eager: true, import: 'default' }),
};
const locales = Object.keys(imports);
const getLocaleMessages = () => {
  const messages = {};

  locales.forEach((locale) => {
    messages[locale] = {};

    for (const [key, values] of Object.entries(imports[locale])) {

      // Convert the filepath into a nested object key for example:
      // '../locales/en/pages/assets.json' -> 'pages.assets'
      const dottedKey = key.split(`/${locale}/`)
          .pop()
          .replace('.json', '')
          .split('/')
          .join('.');

      // Set the contents of the .json file on the object using dot notation
      _.set(messages[locale], dottedKey, values);
    }
  });

  console.log(messages);
  return messages;
}

const numberFormats = {
  en: {
    currency: {
      style: "currency",
      currency: "GBP",
      currencyDisplay: "symbol",
    },
    percent: {
      style: "percent",
    },
    decimal: {
      style: "decimal",
    },
  },
};

const datetimeFormats = {
  en: {
    shortFormat: {
      dateStyle: "short",
    },
    long: {
      year: 'numeric', month: 'short', day: 'numeric',
      hour: 'numeric', minute: 'numeric'
    },
    longer: {
      year: 'numeric', month: 'short', day: 'numeric',
      weekday: 'short', hour: 'numeric', minute: 'numeric'
    },
    longDate:{
      year: 'numeric', month: 'short', day: 'numeric',
    },
    longMonth:{
      year: 'numeric', month: 'long', day: 'numeric',
    }
  },
};


export default createI18n({
  locale: import.meta.env.VITE_DEFAULT_LOCALE,
  fallbackLocale: import.meta.env.VITE_FALLBACK_LOCALE,
  legacy: false,
  messages: getLocaleMessages(),
  numberFormats,
  datetimeFormats,
});